/**
 * Custom Filters - Fan Collection
 * Template-specific configuration for the fan-collection template.
 *
 * These collections (fans-led, fans-smart, fans-fandelier, fans-ac, fans-dc) store a full API
 * slug in their `subcategory` metafield rather than a subcategory name. initFromMetafields
 * passes those through unchanged, so this template needs no special handling of its own.
 *
 * Requires: custom-filters-core.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  window.CustomFilters.initFromMetafields();
});
